import React from"react";
import { useNavigate } from"react-router-dom";
 
export default function NotFound() {
 const navigate = useNavigate();
 
 return (
 <div className="min-h-screen bg-bgMain flex flex-col items-center justify-center p-6 text-center relative overflow-hidden font-sans">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 {/* Illustration block */}
 <div className="relative w-[460px] h-[320px] mb-6 z-10">
 {/* Left 4 */}
 <div className="absolute left-0 top-1/2 -translate-y-1/2 text-[130px] leading-none font-extrabold bg-gradient-to-br from-primary to-secondary bg-clip-text text-transparent">
 4
 </div>
 
 {/* Blob + astronaut (pure SVG) */}
 <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
 <svg width="320" height="240" viewBox="0 0 420 280">
 {/* Blob */}
 <path
 d="M106 27c35-22 74-29 112-18 30 9 57 28 83 46 23 16 50 29 63 54 14 27 8 60-8 84-16 24-43 40-72 49-29 8-60 8-90 3-32-5-64-15-88-36-24-20-41-49-45-80-4-30 2-64 21-86 6-7 14-12 24-16z"
 transform="translate(15 10)"
 fill="#1e293b"
 />
 {/* Stars */}
 <g fill="var(--primary-blue, #4F46E5)" opacity="0.8">
 <circle cx="90" cy="70" r="2" />
 <circle cx="145" cy="45" r="1.6" />
 <circle cx="210" cy="80" r="2.2" />
 <circle cx="320" cy="65" r="1.8" />
 <circle cx="280" cy="120" r="1.6" />
 <circle cx="120" cy="140" r="1.6" />
 <circle cx="200" cy="170" r="2" />
 <circle cx="320" cy="170" r="1.6" />
 <circle cx="260" cy="210" r="1.8" />
 </g>
 
 {/* Astronaut watermelon */}
 <g transform="translate(170 90)">
 <circle cx="40" cy="40" r="48" fill="#F8FAFC" />
 <circle cx="40" cy="40" r="42" fill="#020617" />
 <circle cx="40" cy="40" r="34" fill="#22D3EE" />
 <g fill="var(--primary-blue, #4F46E5)" opacity="0.9">
 <ellipse cx="40" cy="40" rx="5" ry="34" />
 <ellipse cx="27" cy="40" rx="3.5" ry="32" />
 <ellipse cx="53" cy="40" rx="3.5" ry="32" />
 </g>
 <circle cx="28" cy="34" r="4.5" fill="#0F172A" />
 <circle cx="52" cy="34" r="4.5" fill="#0F172A" />
 <path
 d="M28 56c6-6 18-6 24 0"
 fill="none"
 stroke="#0F172A"
 strokeWidth="3"
 strokeLinecap="round"
 />
 <rect x="-4" y="30" width="12" height="20" rx="4" fill="#F8FAFC" />
 <rect x="72" y="30" width="12" height="20" rx="4" fill="#F8FAFC" />
 {/* ERROR tag + small hand */}
 <g transform="translate(-58 42)">
 <rect x="0" y="0" width="62" height="24" rx="6" fill="#7C3AED" />
 <text
 x="31"
 y="16.5"
 textAnchor="middle"
 fontSize="12"
 fontWeight="800"
 fill="#F8FAFC"
 >
 LOST?
 </text>
 <circle cx="64" cy="12" r="10" fill="#7C3AED" />
 <rect x="60" y="8" width="10" height="8" rx="2" fill="#7C3AED" />
 </g>
 </g>
 
 {/* Shapes */}
 <g transform="translate(320 30)">
 <circle cx="12" cy="12" r="12" fill="var(--primary-blue, #4F46E5)" />
 </g>
 <g transform="translate(300 95) rotate(-20)">
 <path d="M0 0c22 6 22 22 0 28C-4 20-4 8 0 0z" fill="#7C3AED" />
 </g>
 <g transform="translate(90 190)">
 <circle cx="16" cy="16" r="14" fill="#22D3EE" />
 </g>
 </svg>
 </div>
 
 {/* Right 4 */}
 <div className="absolute right-0 top-1/2 -translate-y-1/2 text-[130px] leading-none font-extrabold bg-gradient-to-bl from-secondary to-primary bg-clip-text text-transparent">
 4
 </div>
 </div>
 
 {/* Text + Button (centered, like in your earlier style) */}
 <h2 className="text-white text-3xl font-extrabold mb-4 uppercase tracking-tighter z-10">Oops! Page Lost in Space</h2>
 <p className="text-muted text-lg mb-10 max-w-md z-10">
 The feature or page you're looking for doesn't exist or has moved to another dimension.
 </p>
 <button
 onClick={() => navigate("/")}
 className="btn-primary-gradient px-10 py-4 rounded-2xl font-bold shadow-xl hover:scale-105 active:scale-95 transition-all z-10"
 >
 Return to Home Base
 </button>
 </div>
 );
}




